import { Firestore } from '../../config/firebase';
import { collection, query, where, orderBy, limit, onSnapshot, getDocs, doc, getDoc, deleteDoc } from 'firebase/firestore';

//{"prep1":240,"scheduledTime":{"seconds":1746432000,"nanoseconds":0},"raceType":"Fleet","clubId":["fxYlKWQkBHKksdC9cN4k"],"starts":[{"name":"","warn":300,"recallDelay":60,"offset":0,"recallMode":"Hold","completed":null,"prep1":240,"started":null,"prep2":60,"raceState":"NotStarted","prestart":10}],"seriesName":"Golden Jubilee Cup","name":"","raceState":"NotStarted","recallDelay":60,"v":2,"s":2,"started":null,"completed":{"seconds":1746458056,"nanoseconds":213000000},"live":false,"raceNumber":9,"pursuitRaceDeltas":[],"seriesKey":"d40894b1-d46d-46a2-ba0b-cc055117f967","addedBy":"JMO5PJm63ddly4zi4XpzH59hlWq2","offset":0,"pursuitRaceTargetTime":2700,"prestart":10,"warn":300,"prep2":60,"recallMode":"Hold","epoch":{"seconds":1746458053,"nanoseconds":203999000},"id":"af704c9e-66d6-45a3-8616-514aaf7245e2","completedDt":"2025-05-05T15:14:16.213Z","state":"NotStarted"}

const RaceState = Object.freeze({
  NotStarted: 'NotStarted',
  Prestart: 'Prestart',
  Five: 'Five',
  Four: 'Four',
  One: 'One',
  ConfirmStart: 'ConfirmStart',
  IndRecall: 'IndRecall',
  InProgress: 'InProgress',
  Finishing: 'Finishing',
  Finished: 'Finished'
});

function getRaceState(state) {
  if (!state) return RaceState.NotStarted;
  
  const validState = Object.values(RaceState).find(s => s === state);
  if (!validState) {
    console.warn(`Invalid race state: ${state}, defaulting to NotStarted`);
    return RaceState.NotStarted;
  }
  
  return validState;
}

function transformRace(id, data) {
  if (!data) return null;
  data.id = id;
  data.state = getRaceState(data.raceState);
  data.completedDt = data.completed.toDate();
  data.scheduledDt = data.scheduledTime.toDate();
  return data;
}

const racesDb = () => {
  const subscribeAll = async (clubId, raceHandler) => {
    const racesRef = collection(Firestore, 'races');
    const q = query(
      racesRef,
      where('clubId', 'array-contains', clubId),
      orderBy('completed', 'desc'),
      limit(10)
    );
    
    return onSnapshot(q, (snap) => {
      const races = snap.docs.map(doc => transformRace(doc.id, doc.data()));
      raceHandler(races);
    });
  }
  
  const findAll = async (clubId) => {
    const racesRef = collection(Firestore, 'races');
    const q = query(
      racesRef,
      where('clubId', 'array-contains', clubId),
      orderBy('completed', 'desc'),
      limit(10)
    );
    const snap = await getDocs(q);
    return snap.docs.map(doc => transformRace(doc.id, doc.data()));
  }

  const findOne = async (raceId, clubId) => {
    if (!raceId) {
      // If no raceId provided, get the latest race
      const racesRef = collection(Firestore, 'races');
      let q = query(racesRef, orderBy('completed', 'desc'), limit(1));
      
      // If clubId is provided, filter by club
      if (clubId) {
        q = query(q, where('clubId', 'array-contains', clubId));
      }
      
      const snap = await getDocs(q);
      if (snap.empty) {
        return null;
      }
      const doc = snap.docs[0];
      return transformRace(doc.id, doc.data());
    }
    
    const raceRef = doc(Firestore, 'races', raceId);
    const raceSnap = await getDoc(raceRef);
    return transformRace(raceId, raceSnap.data());
  }

  const subscribeOne = async (raceId, callback) => {
    const raceRef = doc(Firestore, 'races', raceId);
    return onSnapshot(raceRef, (snap) => {
      callback(transformRace(raceId, snap.data()));
    });
  }

  const remove = async (raceId, clubId) => {
    const raceRef = doc(Firestore, 'races', raceId);
    await deleteDoc(raceRef);
  }

  return Object.freeze({
    findAll,
    subscribeAll,
    findOne,
    subscribeOne,
    remove
  })
}

const Races = racesDb();

export { Races }
